<template>
  <div class="pt-[31px]">
    <div class="mb-[14px] flex justify-center">
      <img :src="svg1" alt="Eject SIM card" />
    </div>

    <div class="text-[13px] leading-5 text-gpx_black-400">
      Using your fingernail, slide the sim door down towards the charging port.
      The door will open and your SIM card should pop out. Set it aside.
    </div>

    <div class="flex justify-between gap-x-4 pb-[18px] pt-[26px]">
      <Button
        variant="tertiary"
        size="lg"
        class="w-[124px]"
        @click="$emit('onCancel')"
      >
        Back
      </Button>
      <Button @click="$emit('onConfirm')" class="w-full">
        Next
      </Button>
    </div>
  </div>
</template>

<script>
import Step4Svg1 from './assets/step-4.svg';

export default {
  emits: ['onConfirm', 'onCancel'],

  computed: {
    svg1() {
      return Step4Svg1;
    },
  },
};
</script>
